import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { hmSoldOutRedirectReason } from "src/utils/constants";

/**
 * Payment type constants
 */
export enum paymentTypes {
  CREDIT_CARD = "CREDIT_CARD",
  PAYPAL = "PAYPAL",
}

export interface CheckoutState {
  zipcode: string;
  salesTaxAmount: number;
  salesTaxState: string;
  paypalAccount: string;
  paymentType: paymentTypes;
  promoCode: string;
  promoCodeApplied: string;
  promoDiscountAmount: number;
  promoDiscountAmountFormatted: string;
  promoDiscountPercentage: number;
  promoCodeIsVip: boolean;
  promoCodeError: string;
  purchaseError: string | Record<string, string>;
  purchaseErrorCode: string;
  processing: boolean;
  goalMonth: string;
  // TODO(patrick): Move these modal states out of redux and into the component states if possible.
  madeTrialPriceChoice: boolean;
  showFairTrialDisclaimer: boolean;
  shouldShowExitIntentModal: boolean;
  showExitIntentModal: boolean;
  isTimerExpired: boolean;
  walletPay: boolean;
  applePay: boolean;
  googlePay: boolean;
  paymentRequest: any; // react-stripe-elements object

  billingName?: string;
  billingNameChangeMade?: boolean;
  billingAddress?: {
    country: string;
    city: string;
    region: string;
    address1: string;
    address2: string;
    zipcode: string;
  };
  billingAddressErrors?: {
    COUNTRY: boolean;
    CITY: boolean;
    REGION: boolean;
    ADDRESS1: boolean;
    ZIPCODE: boolean;
  };

  showEnrollmentErrors?: boolean;
  stripeError?: Record<string, boolean>;

  soldoutRedirectReason?: hmSoldOutRedirectReason;
}

const initialState: CheckoutState = {
  zipcode: "",
  salesTaxAmount: 0,
  salesTaxState: "",
  paypalAccount: "",
  paymentType: paymentTypes.CREDIT_CARD,
  promoCode: "",
  promoCodeApplied: "",
  promoDiscountAmount: 0,
  promoDiscountAmountFormatted: "",
  promoDiscountPercentage: 0,
  promoCodeIsVip: false,
  promoCodeError: "",
  purchaseError: "",
  purchaseErrorCode: "",
  processing: false,
  goalMonth: "",
  madeTrialPriceChoice: false,
  showFairTrialDisclaimer: false,
  shouldShowExitIntentModal: false,
  showExitIntentModal: false,
  isTimerExpired: false,
  walletPay: false,
  applePay: false,
  googlePay: false,
  paymentRequest: null,
};

const checkoutSlice = createSlice({
  name: "checkout",
  initialState,
  reducers: {
    updateCheckoutState(state, action: PayloadAction<Partial<CheckoutState>>) {
      return { ...state, ...action.payload };
    },
  },
});

export const { updateCheckoutState } = checkoutSlice.actions;

export default checkoutSlice.reducer;
